import {
    IonPage, IonContent, IonAlert, IonInput
} from '@ionic/react';
import React, {Component} from "react";
import './css/PoneAccountRefund.css';
import {uploadImage} from "../../../utils/uploadPic";
import {faceVerify, faceVerifyLogAdd, faceVerifyQuery} from "./Service";
import {getQueryVariable} from "../../../utils/commonFunction"
import {withRouter} from "react-router-dom";
import Script from "react-load-script";
import {captchaKeFuAppId, captchaUrl} from "../../../utils/common";


class PhoneAccountRefund extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isH5: true,
            currpage: 1,
            showTipMsg: null,
            guardianTypeArr: [
                {id: 0, label: '请选择您与孩子的关系'},
                {id: 1, label: '父母'},
                {id: 2, label: '爷爷/奶奶'},
                {id: 3, label: '外公/外婆'},
                {id: 4, label: '其他'}],
            guardianType: 0,
            idName: '',
            idCard: '',
            phone: null,
            sysId: 0,
            accounts: '',
            realName: '',
            idCardPic: null,
            applyIdCardPic: null,
            payPic: [],
            signPic: null,
            amount: null,
            applyRelationPic: [],
            evidencePic: [],
            isYes: false,
            selectedIdCardImages: [],
            selectedApplyIdCardImages: [],
            selectedPayImages: [],
            selectedApplyRelationImages: [],
            selectedEvidenceImages: [],
            isPicUpload: false,
            isPicShow: false,
            picNum: 0,
            picType: 0,
            isFaceVerfy: false,
            isShowIframe: false,
            iframeUrl: '',
        }
    }

    componentDidMount() {
        let pms = getQueryVariable("pm");
        if (pms != null && pms != undefined) {
            this.setState({isFaceVerfy: true})
            this.faceVerifySearch(pms)
        }
    }

    handleScriptError = () => {
        this.setShowTipModal('组件加载失败')
    }
    handleScriptLoad = () => {
        this.setState({
            scriptLoaded: true,
        });
    }

    regPhone = new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)

    returnPageTest = () => {
        const that = this;
        setTimeout(function () {
            that.setState({isPicUpload: false})
        }, 1);
    }

    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null,
            isPicShow: false,
            picNum: 0,
        })
    }

    /**
     * 图片上传页面展示
     * @param type
     */
    uploadPage = (type) => {
        this.setState({
            isPicUpload: true,
            picType: type
        })
    }


    /**
     * 上图图片按钮触发
     * @param idx
     */
    uploadBtnLoad = (idx) => {
        const uploadInput = document.getElementById('upload_' + idx);
        uploadInput.click();
    }

    /**
     * 图片上传
     * @param type  1充值截图 2监护人户口页 3未成年户口页 4出生或监护证明 5举证材料
     * @param event
     * @returns {Promise<void>}
     */
    handleFileInputChange = async (type, event) => {
        const {
            selectedPayImages,
            selectedIdCardImages,
            selectedApplyIdCardImages,
            selectedApplyRelationImages,
            selectedEvidenceImages,
            idCardPic,
            applyIdCardPic,
            payPic,
            applyRelationPic,
            evidencePic
        } = this.state;

        const fileList = event.target.files;
        //console.log(fileList);
        let images = [];
        switch (type) {
            case 1:
                if (selectedPayImages.length + fileList.length > 10) {
                    this.setState({isShowTip: true, showTipMsg: '最多上传10张图片,请重新选择！'})
                    return;
                }
                images = selectedPayImages;
                break;
            case 2:
                if (selectedApplyIdCardImages.length + fileList.length > 1) {
                    this.setState({isShowTip: true, showTipMsg: '最多上传1张图片,请重新选择！'})
                    return;
                }

                images = selectedApplyIdCardImages;
                break;
            case 3:
                if (selectedIdCardImages.length + fileList.length > 1) {
                    this.setState({isShowTip: true, showTipMsg: '最多上传1张图片,请重新选择！'})
                    return;
                }

                images = selectedIdCardImages;
                break;
            case 4:
                if (selectedApplyRelationImages.length + fileList.length > 2) {
                    this.setState({isShowTip: true, showTipMsg: '最多上传2张图片,请重新选择！'})
                    return;
                }

                images = selectedApplyRelationImages;
                break;
            case  5:
                if (selectedEvidenceImages.length + fileList.length > 5) {
                    this.setState({isShowTip: true, showTipMsg: '最多上传5张图片,请重新选择！'})
                    return;
                }

                images = selectedEvidenceImages;
                break;
        }

        let isJpgOrPng = true;
        let isLt2M = true;
        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            //console.log(file)
            isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                this.setState({isShowTip: true, showTipMsg: '只能上传JPG/PNG格式的图片'})
                return;
            }
            isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.setState({isShowTip: true, showTipMsg: '上传图片不能大于10MB'})
                return;
            }
        }

        let realImageUrls = [];

        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            const reader = new FileReader();
            const params = {
                file: file,
                path: 'pc/accountRefund'
            }
            const imageUrl = await uploadImage(params);
            if (imageUrl === "" || imageUrl === null) {
                this.setState({isShowTip: true, showTipMsg: '图片上传失败'})
                return;
            }
            //console.log("imageUrl:" + imageUrl)
            realImageUrls = imageUrl
            if (type === 1) {
                payPic.push(imageUrl);
                realImageUrls = payPic;
            } else if (type === 4) {
                applyRelationPic.push(imageUrl);
                realImageUrls = applyRelationPic;
            } else if (type === 5) {
                evidencePic.push(imageUrl);
                realImageUrls = evidencePic;
            }

            reader.onload = (event) => {
                images.push(event.target.result);
                if (i === fileList.length - 1) {
                    switch (type) {
                        case 1:
                            this.setState({selectedPayImages: images, payPic: realImageUrls})
                            break;
                        case 2:
                            this.setState({selectedApplyIdCardImages: images, applyIdCardPic: realImageUrls})
                            break;
                        case 3:
                            this.setState({selectedIdCardImages: images, idCardPic: realImageUrls})
                            break;
                        case 4:
                            this.setState({selectedApplyRelationImages: images, applyRelationPic: realImageUrls})
                            break;
                        case  5:
                            this.setState({selectedEvidenceImages: images, evidencePic: realImageUrls})
                            break;
                    }
                }
            };
            await reader.readAsDataURL(file);
        }
    }

    /**
     * 删除图片
     * @param index
     */
    handleImageDelete = (index, type) => {
        const {
            selectedPayImages,
            selectedIdCardImages,
            selectedApplyIdCardImages,
            selectedApplyRelationImages,
            selectedEvidenceImages,
            idCardPic,
            applyIdCardPic,
            payPic,
            applyRelationPic,
            evidencePic
        } = this.state;

        let images = [];
        let realImages = [];
        switch (type) {
            case 1:
                images = [...selectedPayImages];
                realImages = [...payPic];
                images.splice(index, 1);
                realImages.splice(index, 1);
                this.setState({selectedPayImages: images, payPic: realImages})
                break;
            case 2:
            case 3:
                images = type === 2 ? [...selectedApplyIdCardImages] : [...selectedIdCardImages];
                realImages = null;
                images.splice(index, 1);
                if (type == 2) {
                    this.setState({selectedApplyIdCardImages: images, applyIdCardPic: realImages})
                } else {
                    this.setState({selectedIdCardImages: images, idCardPic: realImages})
                }
                break;
            case 4:
                images = [...selectedApplyRelationImages];
                realImages = [...applyRelationPic];
                images.splice(index, 1);
                realImages.splice(index, 1);
                this.setState({selectedApplyRelationImages: images, applyRelationPic: realImages})
                break;
            case  5:
                images = [...selectedEvidenceImages];
                realImages = [...evidencePic];
                images.splice(index, 1);
                realImages.splice(index, 1);
                this.setState({selectedEvidenceImages: images, evidencePic: realImages})
                break;
        }
    };

    /**
     * 发起人脸识别
     */
    butFaceVerfy = () => {
        const {idName, idCard, phone, isYes, isH5} = this.state;
        let guardianType = document.getElementById('guardianTypeId').value;
        if (guardianType == 0) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请选择监护人身份'
            })

            return;
        }

        if (idName == '') {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入监护人姓名'
            })

            return;
        }

        if (idCard.length != 15 && idCard.length != 18) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入正确的身份证号'
            })

            return;
        }

        if (!this.regPhone.test(phone)) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请填写正确手机号'
            })

            return;
        }

        if (isYes === false) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请阅读并同意《人脸识别服务协议》，《实名认证协议》，《退款须知》'
            })

            return;
        }

        const urlParms = {
            'guardianType': guardianType,
            'idName': idName,
            'idCard': idCard,
            'phone': phone,
        }

        //console.log(urlParms);
        faceVerify(urlParms, isH5).then(ret => {
            //console.log(ret);
            if (ret.code === '10000') {
                window.location.href = ret.data.certifyUrl;
            } else {
                this.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg
                })
            }
        }).catch(err => {
            console.log(err);
        });
    }

    faceVerifySearchResult = (pm) => {
        if (pm !== '') {
            const parms = {
                'pm': decodeURIComponent(pm),
            }
            faceVerifyQuery(parms, this.state.isH5).then(ret => {
                if (ret.code === '10000') {
                    this.setState({
                        currpage: 2,
                        sysId: ret.data.recordId,
                        isFaceVerfy: false,
                        idCard: '',
                    })
                }else{
                    this.setState({
                        isFaceVerfy: false,
                        isShowTip: true,
                        showTipMsg: ret.msg,
                    })
                }
            }).catch(err => {
                console.log(err);
            });

        }
    }

    /**
     * 人脸识别状态查询
     * @param pm
     */
    faceVerifySearch = (pm) => {
        if (pm !== '') {
            let round = 1;
            const _that = this;
            let myVal = setInterval(function () {
                const parms = {
                    'pm': decodeURIComponent(pm),
                }
                faceVerifyQuery(parms, _that.state.isH5).then(ret => {
                    if (ret.code === '10000') {
                        clearInterval(myVal);
                        _that.setState({
                            currpage: 2,
                            sysId: ret.data.recordId,
                            isFaceVerfy: false,
                            idCard: '',
                        })
                    }
                }).catch(err => {
                    console.log(err);
                });
                //console.log(round);
                if (round > 5) {
                    clearInterval(myVal);
                    _that.faceVerifySearchResult(pm);
                }
                round++;
            }, 2000);
        }
    }

    /**
     * 验证提交
     * @param par 1是下一步  2是提交
     */
    butConfirm = (par) => {
        const {
            sysId,
            accounts,
            realName,
            idCard,
            idCardPic,
            applyIdCardPic,
            payPic,
            signPic,
            amount,
            applyRelationPic,
            evidencePic,
            isYes,
            isH5,
        } = this.state;

        if (accounts === '') {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入退款账号或者ID'
            })

            return;
        }

        if (realName === '') {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入账号实名认证姓名'
            })

            return;
        }

        //console.log(idCard.length)
        if (idCard.length != 15 && idCard.length != 18) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请输入账号实名身份证号'
            })

            return;
        }

        if (amount === 0 || amount === '' || amount === undefined || !Number.isInteger(Number(amount))) {
            this.setState({
                isShowTip: true,
                showTipMsg: '退款金额须为整数且与下方订单金额一致.'
            })

            return;
        }

        if (payPic.length == 0) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请上传对应充值订单截图'
            })

            return;
        }

        let payPicUrl = '';
        for (let i = 0; i < payPic.length; i++) {
            if (i === 0) {
                payPicUrl = payPic[i]
            } else {
                payPicUrl = payPicUrl + "," + payPic[i]
            }
        }

        if (par == 1) {
            this.setState({
                currpage: 3,
            })

            return;
        }

        if (applyIdCardPic === null) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请上传监护人户口页'
            })

            return;
        }

        if (idCardPic === null) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请上传未成年人户口页'
            })

            return;
        }

        /*if (applyRelationPic.length == 0) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请上传出生证明或者监护证明'
            })

            return;
        }*/

        let applyRelationPicUrl = '';
        for (let i = 0; i < applyRelationPic.length; i++) {
            if (i === 0) {
                applyRelationPicUrl = applyRelationPic[i]
            } else {
                applyRelationPicUrl = applyRelationPicUrl + "," + applyRelationPic[i]
            }
        }

        if (signPic == null || (signPic != null && signPic.length < 50)) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请对小孩游戏以及充值情况进行说明，不少于50字'
            })

            return;
        }

        if (idCardPic === null) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请上传未成年人户口页'
            })

            return;
        }

        if (isYes === false) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请您勾选"我是孩子监护人，承诺本次退费不存在故意隐瞒或恶意欺骗的情况，否则将承担全部法律后果。"'
            })

            return;
        }

        let evidencePicUrl = '';
        if (evidencePic.length > 0) {
            for (let i = 0; i < evidencePic.length; i++) {
                if (i === 0) {
                    evidencePicUrl = evidencePic[i]
                } else {
                    evidencePicUrl = evidencePicUrl + "," + evidencePic[i]
                }
            }
        }

        const _that = this;

        // eslint-disable-next-line
        let captcha1 = new TencentCaptcha(captchaKeFuAppId(), function (res) {

            if (res.ret === 0) {


                const urlParms = {
                    'sysId': sysId,
                    'accounts': accounts,
                    'realName': realName,
                    'idCard': idCard,
                    'idCardPic': idCardPic,
                    'applyIdCardPic': applyIdCardPic,
                    'payPic': payPicUrl,
                    'signPic': signPic,
                    'amount': amount,
                    'applyRelationPic': applyRelationPicUrl,
                    'evidencePic': evidencePicUrl,
                    'ticket': res.ticket,
                    'randStr': res.randstr,
                }

                //console.log(urlParms);
                faceVerifyLogAdd(urlParms, isH5).then(ret => {
                    //console.log(ret);
                    if (ret.code === '10000') {
                        _that.setState({
                            isShowTip: true,
                            showTipMsg: ret.data
                        })
                    } else {
                        _that.setState({
                            isShowTip: true,
                            showTipMsg: ret.msg
                        })
                    }
                    captcha1.destroy();
                }).catch(err => {
                    console.log(err);
                    captcha1.destroy();
                });
            }
        }, {bizState: 'RSCNO7XFNGG9r6xB'});

        captcha1.show(); // 显示验证码

    }


    render() {
        return (
            <IonPage>
                <IonContent fullscreen>
                    <Script
                        url={captchaUrl()}
                        onError={this.handleScriptError}
                        onLoad={this.handleScriptLoad}
                    />
                    <div className="sut_cont">
                    {this.state.isPicUpload ?
                        <div>
                            <div className="top_refund pr">
                                <a className="return-refund" onClick={() => this.returnPageTest()}>
                                    <img src={require("../../images/member/refund/return_icon.png")}/>
                                </a>
                                {this.state.picType === 1 && <div className="top_title">充值订单截图</div>}
                                {this.state.picType === 2 && <div className="top_title">监护人户口页</div>}
                                {this.state.picType === 3 && <div className="top_title">未成年人户口页</div>}
                                {this.state.picType === 4 && <div className="top_title">出生或监护证明</div>}
                                {this.state.picType === 5 && <div className="top_title">举证材料</div>}
                            </div>
                            <div className="sut_box">
                                <p className="pl30">{(this.state.picType == 2 || this.state.picType == 3 || this.state.picType == 4) ? '信息仅用于身份验证，浮云保障您的信息安全' : ''}</p>
                                {this.state.picType === 1 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <a className="sut_link pr" onClick={() => this.uploadBtnLoad('pay')}>
                                                <span className="img_icon pa">
                                                    <img src={require("../../images/member/refund/pic_icon.png")}/>
                                                </span>
                                                <p className="nub_tex pa">{this.state.selectedPayImages.length}/10</p>
                                            </a>

                                        </div>
                                        {this.state.selectedPayImages.length > 0 && this.state.selectedPayImages.map((image, index) => (
                                            <div key={index} className="sut_list">
                                                <a onClick={() => this.handleImageDelete(index, 1)}
                                                   className="sut_link pr">
                                                    <span className="slt_img pa"><img src={image} alt=""/></span>
                                                    <p className="nub_tex pa">{index + 1}/10</p>
                                                    <i className="gray_bg pa"></i>
                                                    <em className="close_icon pa">
                                                        <img
                                                            src={require("../../images/member/refund/close_icon.png")}/>
                                                    </em>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                }
                                {this.state.picType === 2 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <a className="sut_link pr"
                                               onClick={() => this.uploadBtnLoad('applyIdCard')}>
                                                <span className="img_icon pa">
                                                    <img src={require("../../images/member/refund/pic_icon.png")}/>
                                                </span>
                                                <p className="nub_tex pa">{this.state.selectedApplyIdCardImages.length}/1</p>
                                            </a>
                                        </div>
                                        {this.state.selectedApplyIdCardImages.length > 0 && this.state.selectedApplyIdCardImages.map((image, index) => (
                                            <div key={index} className="sut_list">
                                                <a onClick={() => this.handleImageDelete(index, 2)}
                                                   className="sut_link pr">
                                                    <span className="slt_img pa"><img src={image} alt=""/></span>
                                                    <p className="nub_tex pa">{index + 1}/1</p>
                                                    <i className="gray_bg pa"></i>
                                                    <em className="close_icon pa">
                                                        <img
                                                            src={require("../../images/member/refund/close_icon.png")}/>
                                                    </em>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                }
                                {this.state.picType === 3 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <a className="sut_link pr" onClick={() => this.uploadBtnLoad('idCard')}>
                                                <span className="img_icon pa">
                                                    <img src={require("../../images/member/refund/pic_icon.png")}/>
                                                </span>
                                                <p className="nub_tex pa">{this.state.selectedIdCardImages.length}/1</p>
                                            </a>
                                        </div>
                                        {this.state.selectedIdCardImages.length > 0 && this.state.selectedIdCardImages.map((image, index) => (
                                            <div key={index} className="sut_list">
                                                <a onClick={() => this.handleImageDelete(index, 3)}
                                                   className="sut_link pr">
                                                    <span className="slt_img pa"><img src={image} alt=""/></span>
                                                    <p className="nub_tex pa">{index + 1}/1</p>
                                                    <i className="gray_bg pa"></i>
                                                    <em className="close_icon pa">
                                                        <img
                                                            src={require("../../images/member/refund/close_icon.png")}/>
                                                    </em>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                }
                                {this.state.picType === 4 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <a className="sut_link pr"
                                               onClick={() => this.uploadBtnLoad('applyRelation')}>
                                                <span className="img_icon pa">
                                                    <img src={require("../../images/member/refund/pic_icon.png")}/>
                                                </span>
                                                <p className="nub_tex pa">{this.state.selectedApplyRelationImages.length}/2</p>
                                            </a>
                                        </div>
                                        {this.state.selectedApplyRelationImages.length > 0 && this.state.selectedApplyRelationImages.map((image, index) => (
                                            <div key={index} className="sut_list">
                                                <a onClick={() => this.handleImageDelete(index, 4)}
                                                   className="sut_link pr">
                                                    <span className="slt_img pa"><img src={image} alt=""/></span>
                                                    <p className="nub_tex pa">{index + 1}/2</p>
                                                    <i className="gray_bg pa"></i>
                                                    <em className="close_icon pa">
                                                        <img
                                                            src={require("../../images/member/refund/close_icon.png")}/>
                                                    </em>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                }
                                {this.state.picType === 5 &&
                                    <div className="clearfix pt30">
                                        <div className="sut_list">
                                            <a className="sut_link pr" onClick={() => this.uploadBtnLoad('evidence')}>
                                                <span className="img_icon pa">
                                                    <img src={require("../../images/member/refund/pic_icon.png")}/>
                                                </span>
                                                <p className="nub_tex pa">{this.state.selectedEvidenceImages.length}/5</p>
                                            </a>
                                        </div>
                                        {this.state.selectedEvidenceImages.length > 0 && this.state.selectedEvidenceImages.map((image, index) => (
                                            <div key={index} className="sut_list">
                                                <a onClick={() => this.handleImageDelete(index, 5)}
                                                   className="sut_link pr">
                                                    <span className="slt_img pa"><img src={image} alt=""/></span>
                                                    <p className="nub_tex pa">{index + 1}/5</p>
                                                    <i className="gray_bg pa"></i>
                                                    <em className="close_icon pa">
                                                        <img
                                                            src={require("../../images/member/refund/close_icon.png")}/>
                                                    </em>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                }
                                <input id="upload_pay" type="file" onChange={e => this.handleFileInputChange(1, e)}
                                       className="file dn" accept="image/*" multiple/>
                                <input id="upload_applyIdCard" type="file"
                                       onChange={e => this.handleFileInputChange(2, e)}
                                       className="file dn" accept="image/*"/>
                                <input id="upload_idCard" type="file" onChange={e => this.handleFileInputChange(3, e)}
                                       className="file dn" accept="image/*"/>
                                <input id="upload_applyRelation" type="file" multiple
                                       onChange={e => this.handleFileInputChange(4, e)}
                                       className="file dn" accept="image/*"/>
                                <input id="upload_evidence" type="file" multiple
                                       onChange={e => this.handleFileInputChange(5, e)}
                                       className="file dn" accept="image/*"/>
                            </div>
                        </div> :
                        <div>
                            <div className="guide-head">
                                <a href="/phone/refundTutelage">监护引导</a>
                                <a href="/phone/refundFlow">申请流程</a>
                                <a href="/h5accountRefund" className="on">点我申请</a>
                            </div>
                            <div className="cont-refund">
                            {/*{!this.state.isClient &&
                                <div className="top_refund pr">
                                    {(this.state.currpage === 1 || this.state.currpage === 2) ?
                                        <a className="return" onClick={() => this.returnPage()}>
                                            <img src={require("../../images/member/refund/return_icon.png")} alt=""/>
                                        </a> :
                                        <a className="return" onClick={() => this.setState({currpage: 2})}>
                                            <img src={require("../../images/member/refund/return_icon.png")} alt=""/>
                                        </a>

                                    }
                                    <div className="top_title">未成年充值退款申请</div>
                                </div>
                            }*/}
                            <div className="liucheng">
                                <div className="step_img">
                                    <img
                                        src={require("../../images/member/refund/step0" + this.state.currpage + "_img.jpg")}/>
                                </div>
                                <div className="step_tex">
                                    {this.state.currpage === 1 &&
                                        <p>未成年人退款申请只能由监护人本人发起，您需要提供身份信息并进行人脸验证</p>}
                                    {this.state.currpage === 2 &&
                                        <p>退款金额需与上传订单明细总金额一致,充值订单截图须包含商户订单号
                                            <a onClick={() => this.setState({isPicShow: true, picNum: 1})}
                                               className="textBlue_refund_phone">（查看示例）</a>
                                        </p>}
                                    {this.state.currpage === 3 && <p>请按照要求完整、清晰的上传所需资料，否则可能导致您此次退款申请失败
                                        <a onClick={() => this.setState({isPicShow: true, picNum: 2})}
                                           className="textBlue_refund_phone">（查看示例）</a>
                                    </p>}
                                </div>
                            </div>
                            {this.state.currpage === 1 &&
                                <div className="Input_box_refund">
                                    <div className="identity clearfix">
                                        <span className="w246">监护人身份</span>
                                        <select className="input-tex-refund" id="guardianTypeId">
                                            {this.state.guardianTypeArr.map(option => (
                                                <option value={option.id}>{option.label}</option>
                                            ))
                                            }
                                        </select>
                                    </div>
                                    <div className="identity clearfix">
                                        <span className="w246">监护人姓名</span>
                                        <IonInput type="text" className="input-tex-refund"
                                                  value={this.state.idName}
                                                  placeholder="填写您的真实姓名"
                                                  onIonChange={e => this.setState({idName: e.detail.value})}/>
                                    </div>
                                    <div className="identity clearfix">
                                        <span className="w246">身份证号</span>
                                        <IonInput type="text" className="input-tex-refund"
                                                  value={this.state.idCard}
                                                  placeholder="填写您的身份证号"
                                                  onIonChange={e => this.setState({idCard: e.detail.value})}/>
                                    </div>
                                    <div className="identity clearfix">
                                        <span className="w246">手机号码</span>
                                        <IonInput type="text" className="input-tex-refund"
                                                  value={this.state.phone}
                                                  placeholder="填写您的联系方式"
                                                  onIonChange={e => this.setState({phone: e.detail.value})}/>
                                    </div>
                                    <div className="Agreed clearfix">
                                        <div onClick={() => this.setState({isYes: !this.state.isYes})}
                                             className={this.state.isYes ? "on" : "choose"}></div>
                                        <p style={{fontSize: '0.12rem'}}>我已阅读并同意
                                             <a href="https://wfw.fuyuncc.com/Compliance/tooldocument/use/100005_0_0_91.html"
                                               className="textBlue_refund_phone">《人脸识别服务协议》</a>
                                            <a href="https://wfw.fuyuncc.com/pc/accountRefund/verifyService.html"
                                               className="textBlue_refund_phone">《实名认证服务协议》</a><br/>
                                            <a href="https://wfw.fuyuncc.com/pc/accountRefund/refundNotice.html"
                                               className="textBlue_refund_phone">《退款须知》</a>
                                        </p>
                                    </div>
                                    <a onClick={() => this.butFaceVerfy()} className="btn-refund">开始人脸识别验证</a>
                                    <a href="/h5accountRefundCheck" className="query">申诉进度查询</a>
                                </div>
                            }
                            {this.state.currpage === 2 &&
                                <div className="Input_box_refund">
                                    <div className="identity clearfix">
                                        <span className="w246">退款游戏账号</span>
                                        <IonInput type="text" className="input-tex-refund"
                                                  value={this.state.accounts}
                                                  placeholder="请输入账号或ID"
                                                  onIonChange={e => this.setState({accounts: e.detail.value})}/>
                                    </div>
                                    <div className="identity clearfix">
                                        <span className="w246">账号实名姓名</span>
                                        <IonInput type="text" className="input-tex-refund"
                                                  value={this.state.realName}
                                                  placeholder="请输入账号实名认证姓名"
                                                  onIonChange={e => this.setState({realName: e.detail.value})}/>
                                    </div>
                                    <div className="identity clearfix">
                                        <span className="w246">账号实名身份证</span>
                                        <IonInput type="text" className="input-tex-refund"
                                                  value={this.state.idCard}
                                                  placeholder="请输入账号实名身份证号"
                                                  onIonChange={e => this.setState({idCard: e.detail.value})}/>
                                    </div>
                                    <div className="identity clearfix">
                                        <span className="w246">退款金额(元)</span>
                                        <IonInput type="text" className="input-tex-refund"
                                                  value={this.state.amount}
                                                  placeholder="退款金额需与下方订单金额一致"
                                                  onIonChange={e => this.setState({amount: e.detail.value})}/>
                                    </div>
                                    <div className="upload clearfix pr" onClick={() => this.uploadPage(1)}>
                                        <span className="w246">对应充值订单截图</span>
                                        <a className="upload_icon">
                                            <img src={require("../../images/member/refund/jt_icon.png")}/>
                                        </a>
                                        {this.state.payPic.length > 0 && <p className="upload_tex pa">已上传</p>}
                                    </div>
                                    <a onClick={() => this.butConfirm(1)} className="btn-refund mt100">下一步</a>
                                </div>
                            }
                            {this.state.currpage === 3 &&
                                <div className="Input_box_refund">
                                    <div className="upload clearfix pr"
                                         onClick={() => this.uploadPage(2)}>
                                        <span className="w246">监护人户口页</span>
                                        <a className="upload_icon"><img
                                            src={require("../../images/member/refund/jt_icon.png")}/></a>
                                        {this.state.applyIdCardPic != null && <p className="upload_tex pa">已上传</p>}
                                    </div>
                                    <div className="upload clearfix pr" onClick={() => this.uploadPage(3)}>
                                        <span className="w246">未成年人户口页</span>
                                        <a className="upload_icon"><img
                                            src={require("../../images/member/refund/jt_icon.png")}/></a>
                                        {this.state.idCardPic != null && <p className="upload_tex pa">已上传</p>}
                                    </div>
                                    <div onClick={() => this.uploadPage(4)}
                                         className="upload clearfix pr">
                                        <span>出生或监护证明(选填)</span>
                                        <a className="upload_icon"><img
                                            src={require("../../images/member/refund/jt_icon.png")}/></a>
                                        {this.state.applyRelationPic.length > 0 &&
                                            <p className="upload_tex pa">已上传</p>}
                                    </div>
                                    <div className="instructions">
                                        <span>未成年人充值行为说明</span>
                                        <textarea name="textarea" id="textarea"
                                                  onChange={e => this.setState({signPic: e.target.value})}
                                                  placeholder="请对小孩游戏及充值情况进行说明，辅以判断审核。如:孩子如何得知游戏账号和支付密码、如何发现孩子充值;孩子与监护人共同居住情况、是否已上学等。"
                                                  className="textarea">{this.state.signPic}</textarea>

                                    </div>
                                    <div className="upload pr">
                                        <div className="clearfix" onClick={() => this.uploadPage(5)}>
                                            <span className="w262">举证材料（选填)</span>
                                            <a href="#" className="upload_icon"><img
                                                src={require("../../images/member/refund/jt_icon.png")}/></a>
                                            {this.state.evidencePic.length > 0 &&
                                                <p className="upload_tex pa">已上传</p>}
                                        </div>
                                        <p className="bz_tex">您可以提供更多的材料，有助于我们更快的完成审核。包括但不限于证明是未成年人消费的图片、视频,未成年人自述事情经过视频等。</p>
                                    </div>
                                    <div className="Agreed clearfix">
                                        <div onClick={() => this.setState({isYes: !this.state.isYes})}
                                             className={this.state.isYes ? "on" : "choose"}></div>
                                        <div className="choose_tex">我是孩子监护人，承诺本次退费不存在故意隐瞒或恶意欺骗的情况，否则将承担全部法律后果。
                                        </div>
                                    </div>
                                    <a onClick={() => this.butConfirm(2)} className="btn-refund">提交</a>
                                    <a href="" className="query"></a>
                                </div>
                            }
                        </div>
                        </div>
                    }
                    </div>
                </IonContent>
                {/*<!-------------------------灰色透明层--------------------->*/}
                {(this.state.isPicShow || this.state.isFaceVerfy || this.state.isShowIframe) && <div className="greybackground"></div>}
                {/*<!-------------------------提示弹窗--------------------->*/}
                {this.state.isPicShow &&
                    <div className="tc02">
                        <div className="tc_bg">
                            <a className="close" onClick={() => this.closeTipBox()}>关闭</a>
                            <div className="tip_tc">
                                <div className={"jt_img0" + this.state.picNum + ""}>
                                    <img src={require("../../images/member/refund/img0" + this.state.picNum + ".jpg")}/>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {this.state.isFaceVerfy &&
                    <div className="tc02">
                        <div className="tc_bg">
                            <div className="tip_tc">
                                <p>人脸识别验证中……</p>
                            </div>
                        </div>
                    </div>
                }
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
};

export default withRouter(PhoneAccountRefund);
